// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AccountExperienceSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="AccountExperienceSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M12.83 9.69s-.09-.688-.24-1.148a3.6 3.6 0 0 0-.733-1.263c-.538-.612-1.26-1.015-2.083-1.055C7.872 6.13 6.34 7.766 6.327 9.67c-.018 2.338 2.075 3.218 3.128 3.414.695.13-1.736 3.095-3.914 2.81-.36-.046-.921-.336-1.174-.572C2.917 13.965 2 12.07 2 9.96c0-2.427 1.358-4.435 3.247-5.363a5.4 5.4 0 0 1 3.348-.473 6.1 6.1 0 0 1 1.702.59c.83.419 1.407.933 1.802 1.47v.002c1.055 1.421.925 3.521.731 3.504" />
      <path d="M18 10.011a8 8 0 0 1-.172 1.753c-1.555 6.966-9.384 6.377-9.392 5.986s3.562-1.585 5.053-4.542c.997-1.978 1.327-4.285.481-6.47-.234-.606-1.258-2.274-2.914-2.957-1.294-.533-3.063-.928-5.403 0C4.849 4.097 4.75 4.03 5.16 3.692 6.718 2.41 8.69 2.129 9.98 2.07c1.524-.068 3.564.407 5.116 1.671C16.797 5.261 18 7.441 18 10.012" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AccountExperienceSignetIcon = /* @__PURE__ */ Object.assign(
  AccountExperienceSignetIconComponent,
  { displayName: 'AccountExperienceSignetIcon' },
);
